import React, { Component } from 'react';

import { DatePickerMode } from '@philips-emr/tws-components-api';
import { array, arrayOf, bool, date, func, oneOf, shape, string } from '@philips-emr/tws-core/lib/component/prop-types';
import { isFunction, isMobile, key } from '@philips-emr/tws-utils';

import { Loader } from '../..';

import { DatePickerAcronyms, DatePickerRow } from '.';

class DatePickerContent extends Component {

  static propTypes = {
    currentDate: date,
    data: array,
    endDate: date,
    interval: bool,
    loading: bool,
    mode: oneOf(Object.values(DatePickerMode)),
    onClick: func,
    ranges: arrayOf(shape({ startDate: string, endDate: string })),
    rangeEnabled: bool,
    startDate: date,
  };

  onCellClick = ({ date }) => {
    const { onClick } = this.props;
    isFunction(onClick) && onClick(date);
  };

  renderAcronyms() {
    return this.props.mode === DatePickerMode.MONTHLY
      ? <DatePickerAcronyms />
      : null;
  }

  renderLoading = () => {
    const { loading } = this.props;

    if (!loading) {
      return null;
    }

    return (
      <Loader className="c-datepicker__loader u-hide@empty" centered size={isMobile() ? 32 : 64}/>
    );
  };

  render() {

    const { currentDate, data, endDate, interval, loading, mode, rangeEnabled, ranges, startDate } = this.props;

    return (
      <div className="c-date-picker__content">
        {this.renderAcronyms()}
        {this.renderLoading()}

        <div className="c-date-picker__rows">
          {data.map((week) => (
            <DatePickerRow
              currentDate={currentDate}
              endDate={endDate}
              interval={interval}
              key={key('c-date-picker-row')}
              loading={loading}
              mode={mode}
              onCellClick={this.onCellClick}
              rangeEnabled={rangeEnabled}
              ranges={ranges}
              row={week}
              startDate={startDate}
            />
          ))}
        </div>
      </div>
    );
  }
}

export default DatePickerContent;
